import { render, staticRenderFns } from "./UserSearchAndAdd.vue?vue&type=template&id=0049521e&scoped=true"
import script from "./UserSearchAndAdd.vue?vue&type=script&lang=js"
export * from "./UserSearchAndAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0049521e",
  null
  
)

export default component.exports